// Token 相关操作
const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'
const LoginFormKey = 'LOGIN_FORM'
const TenantIdKey = 'TENANT_ID'

// 获取token
export function getAccessToken() {
  return localStorage.getItem(AccessTokenKey) || sessionStorage.getItem(AccessTokenKey)
}

// 获取刷新token
export function getRefreshToken() {
  return localStorage.getItem(RefreshTokenKey) || sessionStorage.getItem(RefreshTokenKey)
}

// 设置token
export function setToken(token) {
  if (token.accessToken) {
    localStorage.setItem(AccessTokenKey, token.accessToken)
  }
  if (token.refreshToken) {
    localStorage.setItem(RefreshTokenKey, token.refreshToken)
  }
}

// 删除token
export function removeToken() {
  localStorage.removeItem(AccessTokenKey)
  localStorage.removeItem(RefreshTokenKey)
  sessionStorage.removeItem(AccessTokenKey)
  sessionStorage.removeItem(RefreshTokenKey)
}

// 格式化token（jwt格式）
export function formatToken(token) {
  return 'Bearer ' + token
}

// 登录表单相关
export function getLoginForm() {
  const loginFormStr = localStorage.getItem(LoginFormKey)
  if (loginFormStr) {
    try {
      return JSON.parse(loginFormStr)
    } catch (e) {
      return null
    }
  }
  return null
}

export function setLoginForm(loginForm) {
  localStorage.setItem(LoginFormKey, JSON.stringify(loginForm))
}

export function removeLoginForm() {
  localStorage.removeItem(LoginFormKey)
}

// 租户相关
export function getTenantId() {
  return localStorage.getItem(TenantIdKey) || sessionStorage.getItem(TenantIdKey)
}

export function setTenantId(tenantId) {
  localStorage.setItem(TenantIdKey, tenantId)
}

export function removeTenantId() {
  localStorage.removeItem(TenantIdKey)
  sessionStorage.removeItem(TenantIdKey)
}

// 用户信息相关
const UserInfoKey = 'USER_INFO'

export function getUserInfo() {
  const userInfoStr = localStorage.getItem(UserInfoKey)
  if (userInfoStr) {
    try {
      return JSON.parse(userInfoStr)
    } catch (e) {
      return null
    }
  }
  return null
}

export function setUserInfo(userInfo) {
  localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function removeUserInfo() {
  localStorage.removeItem(UserInfoKey)
  sessionStorage.removeItem(UserInfoKey)
}

// 公司信息相关
const CompanyInfoKey = 'COMPANY_INFO'

export function getCompanyInfo() {
  const companyInfoStr = localStorage.getItem(CompanyInfoKey)
  if (companyInfoStr) {
    try {
      return JSON.parse(companyInfoStr)
    } catch (e) {
      return null
    }
  }
  return null
}

export function setCompanyInfo(companyInfo) {
  localStorage.setItem(CompanyInfoKey, JSON.stringify(companyInfo))
}

export function removeCompanyInfo() {
  localStorage.removeItem(CompanyInfoKey)
  sessionStorage.removeItem(CompanyInfoKey)
}
